export interface FeedItem {
  id: string;
  tag: string;
  time: string;
  title: string;
  digest: string;
  heat: number;
}

export interface CategoryItem {
  id: string;
  name: string;
  icon: string;
  desc: string;
  count: string;
  points: string[];
}

export interface DeepArticle {
  id: string;
  category: string;
  readTime: string;
  title: string;
  summary: string;
  image: string;
  alt: string;
}

export interface FaqItem {
  q: string;
  a: string;
}

export const navLinks = [
  { id: "live", label: "实时追踪" },
  { id: "types", label: "后续形态" },
  { id: "timeline", label: "事件走向" },
  { id: "insight", label: "深度复盘" },
  { id: "guide", label: "追瓜指南" },
  { id: "faq", label: "常见问题" },
];

export const tickerItems = [
  "离婚诉讼进入二审程序，财产分割仍是焦点",
  "当事人深夜发布长文，首次公开回应争议",
  "工作室声明措辞被逐句拆解，舆情二次发酵",
  "品牌方陆续下架合作物料，代言存续引关注",
  "圈内人脉发声，事件走向出现关键反转",
  "网友考古过往采访，旧话与新料相互印证",
];

export const feedItems: FeedItem[] = [
  {
    id: "f1",
    tag: "离婚诉讼",
    time: "今日 09:40",
    title: "二审开庭聚焦财产归属，婚姻存续细节成争议核心",
    digest: "本期诉讼围绕房产、股权与婚前协议展开拉锯，庭审重点从感情破裂转向共同财产界定的证据审查。",
    heat: 92,
  },
  {
    id: "f2",
    tag: "公开回应",
    time: "今日 07:12",
    title: "当事人凌晨发文：用千字长文回应婚变，情绪与措辞成解读焦点",
    digest: "长文出现多处“避重就轻”的表达，网络语义分析显示公众更关注其对“责任”一词的措辞选择。",
    heat: 88,
  },
  {
    id: "f3",
    tag: "道歉",
    time: "昨日 22:05",
    title: "工作室道歉声明发布，避谈核心问题被指诚意不足",
    digest: "公关从业者复盘：道歉若只描述感受而未厘清事实与补偿路径，往往反而会放大信任缺口。",
    heat: 84,
  },
  {
    id: "f4",
    tag: "塌房风险",
    time: "昨日 18:30",
    title: "多品牌调整物料投放，商业合作进入观望期",
    digest: "品牌通常设“道德条款”以规避突发风险，代言存续与否往往是判断事件严重度最直观的信号。",
    heat: 81,
  },
  {
    id: "f5",
    tag: "舆论反转",
    time: "昨日 15:47",
    title: "旧采访被重新考古，过往言论与近期回应相互印证",
    digest: "二次传播阶段，公众倾向于用过往公开素材交叉验证，单一叙事难以长期主导舆论走向。",
    heat: 76,
  },
  {
    id: "f6",
    tag: "圈内发声",
    time: "昨日 11:20",
    title: "合作方与知情者陆续发声，事件可信度评估出现分歧",
    digest: "多方信源彼此交叉又互相矛盾，编辑部提醒：在权威结论前应区分“事实陈述”与“观点表达”。",
    heat: 70,
  },
];

export const categories: CategoryItem[] = [
  {
    id: "divorce",
    name: "离婚诉讼",
    icon: "ri-scales-3-line",
    desc: "聚焦婚姻解除的法律程序：财产分割、子女抚养、抚养费与证据链，是后续进展中信息密度最高的一条线。",
    count: "程序性、可查证",
    points: ["财产归属与婚前协议", "子女抚养安排", "诉讼节点与裁判信息"],
  },
  {
    id: "respond",
    name: "公开回应",
    icon: "ri-megaphone-line",
    desc: "当事人或工作室通过声明、长文、直播等形式回应。措辞、时机与发布渠道共同构成公众解读的坐标。",
    count: "高传播、高解读",
    points: ["回应时机与形式", "措辞语义分析", "是否回应核心问题"],
  },
  {
    id: "apology",
    name: "道歉",
    icon: "ri-emotion-line",
    desc: "道歉是否诚恳、是否聚焦事实与补偿路径，往往决定舆情能否降温，是衡量事件阶段的分水岭。",
    count: "态度关键变量",
    points: ["是否厘清事实", "是否提出补偿路径", "公关逻辑复盘"],
  },
  {
    id: "blacklist",
    name: "封杀与代言",
    icon: "ri-prohibited-line",
    desc: "品牌下架物料、节目调整排期、平台处理等商业与行业连锁反应，常被视为事件严重度的直观晴雨表。",
    count: "行业连锁反应",
    points: ["品牌道德条款", "商务存续观察", "行业合作风向"],
  },
  {
    id: "collapse",
    name: "塌房与反转",
    icon: "ri-arrow-down-circle-line",
    desc: "人设崩塌与信息反转同源：旧料考古、多方信源与舆论风向共同塑造公众对“真实”的重新判断。",
    count: "高不确定性",
    points: ["人设与真实落差", "旧料交叉验证", "反转信号识别"],
  },
];

export const deepArticles: DeepArticle[] = [
  {
    id: "a1",
    category: "传播拆解",
    readTime: "8 分钟",
    title: "一份道歉声明为何越描越黑？危机沟通的三种典型失误",
    summary: "从“避谈核心问题”到“情绪先行”，我们拆解道歉声明最容易踩的三个坑，并给出判断诚意的方法框架。",
    image: "https://readdy.ai/api/search-image?query=editorial%20flat%20lay%20of%20newspaper%20front%20page%20headline%20and%20quill%20on%20warm%20amber%20paper%20desk%2C%20dramatic%20spotlight%2C%20vermillion%20ink%20accents&width=800&height=520&seq=deep-1&orientation=landscape",
    alt: "道歉声明危机沟通复盘，编辑桌前报纸与文字特写",
  },
  {
    id: "a2",
    category: "舆论研究",
    readTime: "6 分钟",
    title: "从爆料到道歉：明星婚变舆论的典型生命周期",
    summary: "事件往往经历爆发、回应、二次发酵、降温四个阶段。看懂节点，才能判断一条消息处在舆论的哪个位置。",
    image: "https://readdy.ai/api/search-image?query=abstract%20rising%20curve%20graph%20with%20glowing%20amber%20line%20over%20dark%20crimson%20background%2C%20minimal%20editorial%20data%20visualization%2C%20soft%20gradient&width=800&height=520&seq=deep-2&orientation=landscape",
    alt: "明星婚变舆论生命周期曲线可视化",
  },
  {
    id: "a3",
    category: "信息素养",
    readTime: "5 分钟",
    title: "反转前的冷静：如何辨别“实锤”与“二手演绎”",
    summary: "信源层级、原始素材与转述加工是三个关键词。掌握基本核查方法，就能在铺天盖地的信息里稳住判断。",
    image: "https://readdy.ai/api/search-image?query=person%20holding%20magnifying%20glass%20over%20scattered%20newspaper%20clippings%20and%20evidence%20folder%2C%20warm%20editorial%20lighting%2C%20amber%20and%20cream%20tone&width=800&height=520&seq=deep-3&orientation=landscape",
    alt: "信息核查，放大镜审阅新闻剪报",
  },
  {
    id: "a4",
    category: "商业观察",
    readTime: "7 分钟",
    title: "品牌为何总在第一时间“沉默”？明星风险与道德条款",
    summary: "代言人出现突发风险时，品牌方的下架、观望与解约各有门道，读解商务动作等于读解事件的行业影响面。",
    image: "https://readdy.ai/api/search-image?query=minimal%20editorial%20illustration%20of%20contract%20document%20with%20signature%20seal%2C%20brand%20logos%20silhouette%20fading%2C%20warm%20vermillion%20and%20amber%20palette&width=800&height=520&seq=deep-4&orientation=landscape",
    alt: "品牌代言风险与合同条款的编辑插画",
  },
];

export const methodSteps = [
  {
    step: "01",
    icon: "ri-time-line",
    title: "锁定信源层级",
    text: "优先区分当事人/工作室的官方声明、可查证的法律文书与平台处理，其次才是媒体转述与网友观点。",
  },
  {
    step: "02",
    icon: "ri-link",
    title: "串联时间节点",
    text: "把爆料、回应、道歉、商务动作按时间排序，观察是否存在沉默期或关键信息的缺失。",
  },
  {
    step: "03",
    icon: "ri-search-line",
    title: "交叉验证旧料",
    text: "用过往采访与公开素材反向比对最新说法，识别“第一次出现”的信息与长期被反复讨论的信息。",
  },
  {
    step: "04",
    icon: "ri-focus-3-line",
    title: "区分事实与观点",
    text: "在权威结论与司法定论出现前，把“陈述”与“评价”分开，避免被单一情绪叙事裹挟。",
  },
];

export const faqs: FaqItem[] = [
  {
    q: "明星婚变消息出来后，为什么官方回应往往慢半拍？",
    a: "涉及法律与商业合约的事项，团队需要先核实事实、评估违约责任并与多方协商，草率发声可能造成新的法律或舆情风险。慢，有时是审慎而非逃避。",
  },
  {
    q: "什么样的道歉更容易获得公众认可？",
    a: "公开传播的研究通常指向三点：厘清事实、不回避核心问题、并提出可验证的补偿或整改路径。若只强调情绪与委屈而忽略事实，容易被解读为缺乏诚意。",
  },
  {
    q: "品牌方为何常在下架与解约之间“观望”？",
    a: "商务合作通常设有道德与声誉条款，但触发解约要依据合同约定与事件定性。短时间内品牌会先降低曝光（下架物料），待事件走向清晰后再决定去留。",
  },
  {
    q: "面对不断反转的信息，普通读者该如何自处？",
    a: "坚持“谁主张谁举证”：优先采信信源清晰、有原始素材、可被多方印证的信息；对只有情绪化表述的内容保持保留，等更多客观节点出现后再下判断。",
  },
  {
    q: "本社的内容如何保证客观与边界？",
    a: "我们只对已经公开、可交叉印证的程序性与传播性信息做复盘与分析，不发布无法核实的私密指控；涉及当事人名誉与未成年人信息的内容一律不作主观演绎。",
  },
];

export const editorPrinciples = [
  { icon: "ri-focus-3-line", title: "信源优先", text: "以官方声明、法律文书与可查证信息为锚点。" },
  { icon: "ri-emotion-2-line", title: "同理有度", text: "复盘事件逻辑，不消费当事人与相关方情绪。" },
  { icon: "ri-file-shield-line", title: "边界清晰", text: "不虚构私密事实，保护未成年人相关信息。" },
  { icon: "ri-refresh-line", title: "持续更新", text: "事件有新进展即校正既有判断，承认不确定性。" },
];

export const voiceQuotes = [
  { name: "一位媒体从业读者", text: "把舆情节点拆成可理解的阶段，比单纯追结果有用得多，回看这些复盘像在补一门传播课。" },
  { name: "长期关注该板块的读者", text: "难得看到有人在海量信息里保持克制，愿意先区分事实与评价再说话。" },
  { name: "品牌公关方向读者", text: "对商务动作与道歉逻辑的解读很专业，做危机预案时能直接参考。" },
];

export const subscribeNote =
  "留下邮箱，重大事件进入关键节点（正式回应、公开道歉、代言处理、程序性进展）时，第一时间给你一封不打扰的复盘简报。";